import { useState, useEffect } from "react";
import { Grid, Box, List, ListItem, ListItemIcon, ListItemText, Button } from '@mui/material';
import MainCard from './MainCard';
import axios from "../../components/axios";
import { useNavigate, useParams } from 'react-router-dom';
import KeyIcon from '@mui/icons-material/Key';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NumbersIcon from '@mui/icons-material/Numbers';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SummarizeIcon from '@mui/icons-material/Summarize';
import StableBuildTreeFix from '../components/StableBuildTreeFix';
import { gridSpacing } from '../../store/constant';
import { useSelector } from 'react-redux';



const TestDetailCard = () => {
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const { token } = useParams();
    const [stableBuild, setStableBuild] = useState({});
    const [newBuild, setNewBuild] = useState({});
    const [jenkinsJob, setJenkinsJob] = useState("");
    const [buildNumber, setBuildNumber] = useState("");
    const [triggerTime, setTriggerTime] = useState("");
    const [testRun, setTestRun] = useState("");
    const [testSuite, setTestSuite] = useState("");

    useEffect(() => {
      const getAgentInfo = async () => {
        try {
          var input_data = JSON.stringify({ token: token});
          const response = await axios.post("/peloton/v1/automation/combination-detail", input_data, { withCredentials: true});
          if (response.data.message === "success"){
            setJenkinsJob(response.data.jenkins_job);
            setBuildNumber(response.data.build_number);
            setTriggerTime(response.data.update_time);
            setTestRun(response.data.test_run);
            setTestSuite(response.data.test_suite);
            setStableBuild(response.data.stable_version);
            setNewBuild(response.data.new_version);
          }
        } catch (error) {
            if (error.response.status !== null){
                if (error.response.status === 401){
                    alert(error.response.data.message);
                    navigate("/");
                }else{
                    console.log('error.response.status: ', error.response.status)
                    console.log('error.response.message: ', error.response.data.message)
                }
            }else{
                console.log(error);
            }
        }
    };
    getAgentInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ token ]);

    const handleOpenResult = async () => {
      if (testRun.length > 1) {
        let resultNumber = testRun.slice(1)
        window.open("https://pelotime.testrail.net/index.php?/runs/view/"+resultNumber+"&group_by=cases:section_id&group_order=asc", "_blank");
      }
    }

    return (
    <MainCard title="Test Detail">
    <Box sx={{ bgcolor: '#E3F2FD' }}>
       <List sx={{ width: '100%', }} aria-label="contacts">
            <ListItem disablePadding>
                <ListItemIcon sx={{ color: '#0081C9' }}>
                  <KeyIcon />
                </ListItemIcon>
                <ListItemText primary="Token" primaryTypographyProps={{ fontSize: 14, color: '#0000008a' }}/>
            </ListItem>
            <ListItem disablePadding>
                <ListItemText inset primaryTypographyProps={{ fontSize: 14 }} primary={token} />
            </ListItem>

            <ListItem disablePadding sx={{ pt: 1 }}>
                <ListItemIcon sx={{ color: '#FF6464' }}>
                  <NotificationsActiveIcon />
                </ListItemIcon>
                <ListItemText primary="Jenkins Job" primaryTypographyProps={{ fontSize: 14, color: '#0000008a' }}/>
            </ListItem>
            <ListItem disablePadding>
                <ListItemText inset primaryTypographyProps={{ fontSize: 14 }} primary={jenkinsJob} />
            </ListItem>

            <ListItem disablePadding sx={{ pt: 1 }}>
                <ListItemIcon sx={{ color: '#FFC93C' }}>
                  <NumbersIcon />
                </ListItemIcon>
                <ListItemText primary="Build Number" primaryTypographyProps={{ fontSize: 14, color: '#0000008a' }}/>
            </ListItem>
            <ListItem disablePadding>
                <ListItemText inset primaryTypographyProps={{ fontSize: 14 }} primary={buildNumber} />
            </ListItem>

            <ListItem disablePadding sx={{ pt: 1 }}>
                <ListItemIcon sx={{ color: '#86C8BC' }}>
                  <AccessTimeIcon />
                </ListItemIcon>
                <ListItemText primary="Trigger Time" primaryTypographyProps={{ fontSize: 14, color: '#0000008a' }}/>
            </ListItem>
            <ListItem disablePadding>
                <ListItemText inset primaryTypographyProps={{ fontSize: 14 }} primary={triggerTime} />
            </ListItem>

            <Grid container>
            <Grid item xs={2}>
            <ListItem disablePadding sx={{ pt: 1 }}>
                <ListItemIcon sx={{ color: '#7FBCD2' }}>
                  <SummarizeIcon />
                </ListItemIcon>
                <ListItemText primary="Test Suite" primaryTypographyProps={{ fontSize: 14, color: '#0000008a' }}/>
            </ListItem>
            <ListItem disablePadding>
                <ListItemText inset primaryTypographyProps={{ fontSize: 14 }} primary={testSuite} />
            </ListItem>
            </Grid>
            <Grid item xs={2}>
            <ListItem disablePadding>
                <ListItemText inset primary="Test Run" primaryTypographyProps={{ fontSize: 14, color: '#0000008a' }}/>
            </ListItem>
            <ListItem disablePadding>
                <ListItemText inset primaryTypographyProps={{ fontSize: 14 }} primary={testRun} />
            </ListItem>
            </Grid>
            <Grid item xs={2}>
              <ListItem>
                  {testRun && (<Button variant="outlined" onClick={handleOpenResult}>Test Report</Button>)}
              </ListItem>
            </Grid>
            <Grid item xs={6}>
            </Grid>
            </Grid>
          </List>
    </Box>
    <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "20px"}}>
                {customization.login && (<StableBuildTreeFix stableBuild={stableBuild} newBuild={newBuild}/>)}
        </Grid>
    </MainCard>
    );
};

export default TestDetailCard;
